<template>
  <HstRequestDetail v-if="isRender" :data="hstRequestDetailData"/>
</template>

<script>
import HstRequestDetail from "@/components/mock/common/HSTRequestDetail";
export default {
  data() {
    return {
      isRender: false,
      hstRequestDetailData: {}
    };
  },
  props: {
    requestDetailData: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  components: { HstRequestDetail },
  methods: {
    findHstDetail() {
      let api = this.getHstRequestDetail;
      let success = this.getHstRequestDetailSuccess;
      let error = this.getHstRequestDetailError;
      this.apiCall(api, success, error);
    },
    getHstRequestDetail(client){
      return client.apis.internalHst.getHstRequestDetailPOST({
        body: { receiptNumber: this.requestDetailData.receptionNumber }
      });
    },
    getHstRequestDetailSuccess(result) {
      this.hstRequestDetailData = result.obj.applicationDetails;
      this.isRender = true;
    },
    getHstRequestDetailError(error) {
      // this.showErrorMessage(error);
    },
  },
  created() {
    this.findHstDetail();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/mock/philips/call/components/HstRequestDetailCard.vue